import GlobalConfigPage from '@/pages/globalConfig/GlobalConfigPage.vue'

export default [
  {
    path: '/globalConfig/',
    component: GlobalConfigPage,
    props: true
  }
]
